var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContactActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 2.5,
    width: 21.875,
    height: 25,
    rx: 5,
    stroke: "#2177FE",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2375 17.176C12.4516 17.7025 10.3908 18.7776 11.6459 20.1229C12.2591 20.78 12.9419 21.25 13.8005 21.25H18.6995C19.5581 21.25 20.2409 20.78 20.8541 20.1229C22.1092 18.7776 20.0484 17.7025 19.2625 17.176C17.4193 15.9413 15.0807 15.9413 13.2375 17.176Z",
    stroke: "#2177FE",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 11.25C18.75 12.6307 17.6307 13.75 16.25 13.75C14.8693 13.75 13.75 12.6307 13.75 11.25C13.75 9.86929 14.8693 8.75 16.25 8.75C17.6307 8.75 18.75 9.86929 18.75 11.25Z",
    stroke: "#2177FE",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 7.5L3.125 7.5M6.25 15L3.125 15M6.25 22.5H3.125",
    stroke: "#2177FE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactActive);
export default __webpack_public_path__ + "static/media/contactActive.952bfd4ff50286aae9e0c4e38373fa46.svg";
export { ForwardRef as ReactComponent };